import { Button, Grid, Snackbar, Typography } from "@mui/material";
import { useStyles } from "./InfoToastStyle";
import React, { useState } from "react";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

interface InfoToastProps {
  open: boolean;
  showButton: boolean;
}
export const InfoToast = ({ open, showButton }: InfoToastProps) => {
  const classes = useStyles();
  const [info, setInfo] = useState<boolean>(open);

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setInfo(false);
  };

  const Info = (
    <React.Fragment>
      <Grid container sx={{ width: "1100px" }}>
        <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
          <Typography>
            Please go to ‘IT and Technology’ through the elevator. You will meet
            a technology specialist in the server room.
          </Typography>
          {showButton && (
            <Button
              variant="contained"
              sx={{ borderRadius: "50px", textTransform: "capitalize" }}
              endIcon={<ArrowForwardIcon />}
            >
              Go to elevator
            </Button>
          )}
        </Grid>
      </Grid>
    </React.Fragment>
  );

  return (
    <>
      <Snackbar
        className={classes.msgAlignment}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={info}
        // autoHideDuration={6000}
        message={Info}
        onClose={handleClose}
      />
    </>
  );
};
